/* eslint-disable no-alert */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subject", "message"];
  static values = { url: String, proposalId: String  };

  dismiss() {
    event.preventDefault()
    fetch(this.urlValue, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ proposal_id: this.proposalIdValue, subject: this.subjectTarget.value, message: this.messageTarget.value })
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "success") {
        location.reload();
      } else {
        alert("Failed to decline requested update.");
      }
    })
    // eslint-disable-next-line no-console
    .catch((error) => console.error("Error:", error));
}
}
